
import navigationServices from "../services/navigationServices";

class AuthService {

    getConnectedKey() {
        const v_key = localStorage.getItem("userKey");
        console.log("getConnectedKey :"+v_key);
        return v_key
    };

    setConnectedKey(p_key) {
        console.log("setConnectedKey: "+p_key)
        //Si l'utilisateur s'est connecté sur sont compte, on garde sa clé pour la prochaine fois
        localStorage.setItem("userKey", p_key);
    };

    setUnconnectedKey() {
        console.log("setUnconnectedKey");
        localStorage.removeItem("userKey");
    };

    async logout(p_setkey) {
        
        console.log("setUnconnectedKey");
        localStorage.removeItem("userKey");
        p_setkey(null);
        // Redirection via navigate
        navigationServices.navigateTo("/");
    }
}

export default new AuthService();